export const SPACER_HEIGHT_PX = 8;
export const MENU_ITEM_HEIGHT_PX = 45;
export const OVERFLOW_BUTTON_HEIGHT_PX = 48;
